import { InjectionToken } from '@angular/core';

export const TIME_ZONE = new InjectionToken<string>('TIME_ZONE');
